<template>
    <div class='member-data'>
        <div class="member-data-header fx-v-center">
            <date-picker v-model="datePickerValue" @change="datePickerChange"/>
            <!-- <span>当前共有会员 <span class="green-color">{{ memberSumData.member_count }}</span> 位，会员总余额 <span class="green-color">{{ memberSumData.member_balance_sum }}</span> 元</span> -->
        </div>
        <el-table v-loading="isLoading"
            ref="elTable"
            :data="getSum"
            :height="'calc(100vh - 195px)'"
            :empty-text="isLoading ? ' ' : '暂无数据'"
            @sort-change="sortChange">
            <el-table-column
                label="时间"
                min-width="120">
                <template v-slot="{ row }">
                    <p>{{ row.date }}</p>
                </template>
            </el-table-column>
            <el-table-column
                label="充值金额(元)"
                min-width="120"
                align="right">
                <template v-slot="{ row }">
                    <p class="text-popper" v-textPopper v-numberAlign>{{ row.recharge_amount }}</p>
                </template>
            </el-table-column>
            <el-table-column
                label="充值笔数"
                min-width="120"
                align="right"
                sortable="custom">
                <template v-slot="{ row }">
                    <p class="pr-24">{{ +(row.recharge_count) }}</p>
                </template>
            </el-table-column>
            <el-table-column
                label="余额消费金额(元)"
                min-width="160"
                align="center">
                <template v-slot="{ row }">
                    <p class="text-popper" v-textPopper v-numberAlign>{{ row.consume_amount }}</p>
                </template>
            </el-table-column>
            <el-table-column
                label="余额消费笔数"
                min-width="120"
                align="right">
                <template v-slot="{ row }">
                    <p class="text-popper" v-textPopper>{{ +(row.consume_count) }}</p>
                </template>
            </el-table-column>
            <el-table-column
                label="新增会员"
                min-width="120"
                align="right">
                <template v-slot="{ row }">
                    <p class="text-popper" v-textPopper>{{ +(row.member_registered) }}</p>
                </template>
            </el-table-column>
            <el-table-column min-width="80"/>
            <el-table-column
                label="操作"
                width="80">
                <template v-slot="{ $index, row }">
                    <button style="padding: 0" class="text-btn" @click="toRechargeRecord($index, row)">详情</button>
                </template>
            </el-table-column>
            <p v-if="getSum.length > 0 && !isLoading" slot="append" style="text-align: center; padding: 10px;">没有更多了</p>
            <!-- <p v-if="isHasMore && isScrollLoading" slot="append" style="text-align: center; padding: 10px;">
                <span class="loading-step-animation">正在加载...</span>
            </p>
            <p v-if="(!(isHasMore && isScrollLoading)) && getSum.length > 0" slot="append" style="text-align: center; padding: 10px;">没有更多了</p> -->
        </el-table>
    </div>
</template>

<script lang='ts'>
import DatePicker from '@/components/date_picker/date_picker.vue'
import { createComponent, ref, Ref, onBeforeMount, onMounted, SetupContext, computed } from '@vue/composition-api'
import { openMessage, useScrollLoad } from '@/utils/system.tsx'
import { getOneMonthValue } from '@/utils/index'
import $fetch from '../../../api'
import dayjs from 'dayjs'
import clone from 'lodash/cloneDeep'
import { setObjectItemToFixed } from '@/utils/index'

export default createComponent({
    setup(props, ctx: SetupContext) {
        const datePickerValue: Ref<any> = ref(getOneMonthValue())
        const memberData = ref([])
        const memberSumData = ref({})
        const isLoading = ref(false)
        const { page: oPage, isLoading: isScrollLoading, isHasMore, bindListener, initScrollLoad } = useScrollLoad()

        const oRouter = ctx.root.$router

        // not reactive data and methods
        let firstMemberData = []
        let curOrder: 'ascending' | 'descending' | null = null
        let oLimit: number = 20
        let oFromDate: string = ''
        let oToDate: string = ''

        const format = (t?: string) => dayjs(t).format('YYYY-MM-DD')

        // sum
        const getSum = computed(() => {
            if (memberData.value.length === 0) {
                return []
            }
            const sumObj = memberData.value.reduce((next, prev) => {
                Object.entries(prev).forEach(([k, v]) => {
                    if (k === 'date') {
                        return
                    }
                    next[k] += +(v as string)
                })
                return next
            }, {
                date: '累计',
                recharge_amount: 0,
                recharge_count: 0,
                consume_amount: 0,
                consume_count: 0,
                member_registered: 0
            })
            Object.entries(sumObj).forEach(([k, v]) => {
                if (k === 'date') {
                    return
                }
                sumObj[k] = (+v).toFixed(2)
            })
            return setObjectItemToFixed([sumObj].concat(memberData.value))
        })

        // 组件的入口
        onBeforeMount(() => {
            oLimit = 20
            oFromDate = dayjs().subtract(1, 'month').format('YYYY-MM-DD')
            oToDate = format()
            isLoading.value = true
            Promise.all([getMemberData(), getSumData()])
                .then(() => isLoading.value = false)
        })

        // onMounted(() => {
        //     bindListener({
        //         dom: (ctx.refs.elTable as any).$el.querySelector('.el-table__body-wrapper'),
        //         loadFunction: getMemberData
        //     })
        // })

        const getMemberData = (page = oPage.value, limit = oLimit, fromDate = oFromDate, toDate = oToDate) => {
            return $fetch.post({
                url: '/finance/getmembershipstatistics',
                params: {
                    page,
                    limit,
                    from_date: fromDate,
                    to_date: toDate
                }
            }).then(data => {
                console.log('会员数据', clone(data))
                firstMemberData = clone(data)
                memberData.value = data
                // if (page === 1) {
                //     memberData.value = data.orders
                //     initScrollLoad(data)
                // } else {
                //     memberData.value = memberData.value.concat(data.orders)
                // }
                return data
            }).catch(e => openMessage('error', e.message || '获取会员数据失败'))
        }

        const getSumData = () => {
            return $fetch.post({
                url: '/finance/getmembershipsummary'
            }).then(data => {
                console.log('会员汇总信息', clone(data))
                memberSumData.value = setObjectItemToFixed(data)
            }).catch(e => openMessage('error', e.message || '获取会员数据失败'))
        }

        // date picker change事件
        const datePickerChange = () => {
            oPage.value = 1
            if (datePickerValue.value === null) {
                // 清空的情况
                oFromDate = dayjs().subtract(1, 'month').format('YYYY-MM-DD')
                oToDate = format()
            } else {
                oFromDate = format(datePickerValue.value[0])
                oToDate = format(datePickerValue.value[1])
            }
            isLoading.value = true
            Promise.all([getMemberData(), getSumData()])
                .then(() => isLoading.value = false)
        }

        const toRechargeRecord = (i, row) => {
            if (i !== 0) {
                oRouter.push({
                    name: 'rechargeRecord',
                    params: {
                        start_date: row.date,
                        end_date: row.date
                    }
                })
            } else {
                oRouter.push({
                    name: 'rechargeRecord',
                    params: {
                        start_date: oFromDate,
                        end_date: oToDate
                    }
                })
            }
        }

        const sortChange = (params) => {
            curOrder = params.order
            handleSort()
        }

        const handleSort = () => {
            const curMemberData = clone(firstMemberData)
            switch (curOrder) {
                case 'ascending':
                    memberData.value = curMemberData.sort((a, b) => {
                        if (a.recharge_count !== b.recharge_count) {
                            return b.recharge_count - a.recharge_count
                        } else {
                            return b.consume_amount - a.consume_amount
                        }
                    })
                    break
                case 'descending':
                    memberData.value = curMemberData.sort((a, b) => {
                        if (a.recharge_count !== b.recharge_count) {
                            return a.recharge_count - b.recharge_count
                        } else {
                            return a.consume_amount - b.consume_amount
                        }
                    })
                    break
                default:
                    memberData.value = curMemberData
                    break
            }
        }

        return {
            // data
            isScrollLoading,
            isHasMore,
            isLoading,
            datePickerValue,
            memberData,
            memberSumData,
            // computed
            getSum,
            // methods
            datePickerChange,
            toRechargeRecord,
            sortChange
        }
    },
    components: {
        DatePicker
    }
})
</script>

<style lang="scss" scoped>
::v-deep .el-date-editor {
    margin-right: 20px;
}

.member-data-header {
    margin-top: 12px;
    font-size: 14px;

    > span {
        line-height: 22px;

        .green-color {
            color: #009688;
        }
    }
}
</style>